// Shared definition of the pages that live under the Bookings section.
// Used by both booking_shell (left nav) and booking_dashboard_shell (landing
// cards) so the two stay in sync. Routes are keyed by tenant type because the
// CM, TBN, and FastTrak fleets each have their own actuals components.
//
// The troubleshoot and stats pages are shared components driven by a `source`
// query param (cm/tbn/fasttrak), so each tenant type passes its own source.

const TBN_PAGES = [
  { name: 'Bookings & Actuals', route: 'actuals_tbn', description: 'Review processed booking actuals matched against telematics.' },
  { name: 'Driver Actuals', route: 'driver_actuals_tbn', description: 'Driver booking timeline (HOS on → off) for the selected day.' },
  { name: 'Vehicle Actuals', route: 'vehicle_actuals_tbn', description: 'Vehicle booking timeline (location start → finish) for the selected day.' },
  { name: 'Actuals Troubleshooter', route: 'actuals_troubleshooter', query: { source: 'tbn' }, description: 'Investigate actuals processing errors and warnings by booking.' },
  { name: 'Actuals Stats', route: 'actuals_stats', query: { source: 'tbn' }, description: 'Planned vs. actual summary statistics across bookings.' },
  { name: 'Booking Update History', route: 'booking_update_history', description: 'History of booking record updates received from TBN over a date range.' },
  { name: 'Overlap Updates', route: 'overlap_updates_history', description: 'History of overlap allocator changes to actuals for troubleshooting.' },
]

const CM_PAGES = [
  { name: 'Bookings & Actuals', route: 'actuals', description: 'Review processed booking actuals matched against telematics.' },
  { name: 'Driver Actuals', route: 'driver_actuals', description: 'Driver booking timeline (HOS on → off) for the selected day.' },
  { name: 'Vehicle Actuals', route: 'vehicle_actuals', description: 'Vehicle booking timeline (location start → finish) for the selected day.' },
  { name: 'Actuals Troubleshooter', route: 'actuals_troubleshooter', query: { source: 'cm' }, description: 'Investigate actuals processing errors and warnings by movement.' },
  { name: 'Actuals Stats', route: 'actuals_stats', query: { source: 'cm' }, description: 'Planned vs. actual summary statistics across movements.' },
  { name: 'Booking File History', route: 'booking_file_list', description: 'History of booking file updates, filterable by date range or type.' },
  { name: 'Overlap Updates', route: 'overlap_updates_history', description: 'History of overlap allocator changes to actuals for troubleshooting.' },
]

const FASTTRAK_PAGES = [
  { name: 'Bookings & Actuals', route: 'actuals_fasttrak', description: 'Reservations matched to telematics after the scheduled end time.' },
  { name: 'Actuals Troubleshooter', route: 'actuals_troubleshooter', query: { source: 'fasttrak' }, description: 'Investigate actuals processing errors and warnings by reservation.' },
]

// FI-2133: moovs has a bookings list but no actuals processor yet, so it gets
// the reservation view without the troubleshooter (which reads actuals errors).
const MOOVS_PAGES = [
  { name: 'Bookings', route: 'actuals_moovs', description: 'Reservations pulled from Moovs, by pickup or finish date.' },
]

export function getBookingPages(tenantType) {
  if (tenantType === 'TBN') return TBN_PAGES
  if (tenantType === 'FASTTRAK') return FASTTRAK_PAGES
  if (tenantType === 'CM') return CM_PAGES
  if (tenantType === 'MOOVS') return MOOVS_PAGES
  return []
}
